module.exports = __webpack_public_path__ + "static/neunsight-logo-8652d2373a598bee1d50eed709bc35da.png";